.sa-chat-wrapper
  button#sa-toggle-chat.sa-chat-tab(tabindex="0", onclick=`_sa.toggleChat()`)
    div.sa-message-count(aria-hidden="true")=0
    span.sa-message-announce(aria-live="polite")=''
    span.sa-chat-state-announce(aria-live="polite")=''
    if chatTabImage 
      img.chat-tab-image(src=chatTabImage, alt=chatTabText ? '' : usePhrase('Open Chat'))
    if chatTabText
      span.chat-tab-text=chatTabText
  .sa-chat-slideout
    include ./header.pug
    #sa-chat-app(aria-live="polite")